<template>
  <b-modal
    id="reset-password-modal"
    title="Réinitialiser le mot de passe"
    @ok="handleOk"
    ok-title="Envoyer"
    ok-variant="danger"
    cancel-title="Annuler"
  >
    <div v-if="selectedUser !== null">
      <div>
        Cette action enverra un email à {{selectedUser.lastName}} {{selectedUser.firstName}} ({{selectedUser.username}}) afin qu'il ou elle puisse changer son mot de passe.
      </div>
    </div>
  </b-modal>
</template>

<script>
    import api from '../../services/api';

    export default {
        name: "ResetPasswordModal",

        props: {
            selectedUser: Object
        },

        emits: ['didSendResetPassword'],

        methods: {

            handleOk(bvModalEvt) {
                bvModalEvt.preventDefault() // Prevent modal from closing
                this.handleSubmit()
            },

            handleSubmit() {
                var data = new FormData();
                data.append('username', this.selectedUser.username);

                api({
                    method:'POST',
                    url: `/user/sendResetPasswordEmail`,
                    data: data
                })
                    .then((response) => {
                        this.$emit('didSendResetPassword')
                        this.hideModal()
                        this.successToast()
                    })
                    .catch((error) => {
                        if (error.response.status === 418) {
                            this.$bvToast.toast(error.response.data.message, {
                                autoHideDelay: 2000,
                                toaster: 'b-toaster-bottom-right'
                            })
                        }
                    });
            },

            hideModal() {
                this.$bvModal.hide('reset-password-modal')
            },

            successToast() {
                this.$bvToast.toast(`Email envoyé !`, {
                    autoHideDelay: 2000,
                    toaster: 'b-toaster-bottom-right',
                    noCloseButton: true
                })
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/user/ResetPasswordModal.vue